
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import NrTag from '@nextrequestco/components/src/components/NrTag/NrTag.vue'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import NrSelect from '@nextrequestco/components/src/components/NrSelect/nr-select.vue'
import NrLoadingAnimation from '@nextrequestco/components/src/components/NrLoadingAnimation/nr-loading-animation.vue'
import { debounce, throttle } from 'lodash'
import { mapActions, mapState } from 'vuex'

interface Tag {
  id: number
  name: string
}
export default {
  name: 'RequestTags',
  components: {
    NrIconButton,
    NrModal,
    NrTag,
    NrTooltip,
    NrSelect,
    NrLoadingAnimation
  },
  props: {
    requestId: {
      type: String
    },
    tags: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      updating: false,
      showModal: false,
      requestTags: []
    }
  },
  mounted() {
    this.handleTagSearch = debounce(this.handleTagSearch, 400)
  },
  computed: {
    ...mapState('request_show', [
      'request',
      'dataFetchState',
      'dataOptions',
      'filteredRequestLoading'
    ]),

    canUpdateRequest(): boolean {
      return this.$ability.can('update', 'Request')
    },
    filteredTags() {
      return this.dataOptions.tags.map((tag: Tag) => ({
        label: tag.name,
        value: tag.id
      }))
    }
  },
  methods: {
    ...mapActions('request_show', [
      'updateRequest',
      'fetchRequestTags',
      'fetchTimeline',
      'fetchDataOptions'
    ]),

    handleTagScroll: throttle(function () {
      this.fetchDataOptions({
        searchText: this.dataFetchState.tags.search_text,
        dataType: 'tags'
      })
    }, 400),

    handleTagSearch: throttle(function (searchText = '') {
      this.fetchDataOptions({ searchText, dataType: 'tags' })
    }, 400),

    async handleSaveTags() {
      try {
        await this.updateRequest({
          request_id: this.requestId,
          tag_ids: this.requestTags.map(({ value }) => value)
        })
        await this.fetchRequestTags(this.requestId)
        await this.fetchTimeline({ pretty_id: this.requestId })
        this.$toasted.success('Successfully updated tags.')
      } catch (error) {
        this.$toasted.error(
          'There has been an error saving tags. Please refresh the page and try again.'
        )
      }
      this.updating = false
      this.toggleModal(false)
    },

    toggleModal(state?: boolean) {
      this.showModal = state ?? !this.showModal
      if (this.showModal) this.handleTagSearch()

      this.requestTags = this.tags.map((tag: Tag) => ({
        label: tag.name,
        value: tag.id
      }))
    }
  }
}
